// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';
import { Intro } from 'gandi.react-public-layout';
import type { TranslatorProps } from '@gandi/translate';

import DocumentationGuide from './DocumentationGuide';
import styles from './DocumentationGuides.scss';

type Props = {|
  translator: TranslatorProps,
|};

function DocumentationGuides(props: Props): React.Element<typeof Base> {
  const {
    translator: { __ },
  } = props;

  return (
    <Base>
      <Intro title={__("Gandi's help guides & documentation")}>
        <Base marginBottom="base" className={styles.root}>
          <DocumentationGuide
            icon="privacy"
            title={__('Account Management')}
            description={__(
              'User account information, login, and security setings.'
            )}
            href={__('https://docs.gandi.net/en/account_management/index.html')}
          />

          <DocumentationGuide
            icon="share"
            title={__('Sharing & Collaboration')}
            description={__(
              'Organizations, teams, permissions, and quickshare.'
            )}
            href={__('https://docs.gandi.net/en/sharing_products/index.html')}
          />

          <DocumentationGuide
            icon="domainWire"
            title={__('Domain names')}
            description={__(
              'Management and configuration of your domains at Gandi.'
            )}
            href={__('https://docs.gandi.net/en/domain_names/index.html')}
          />

          <DocumentationGuide
            icon="cart"
            title={__('Marketplace')}
            description={__(
              'A way to quickly link some services to your domains.'
            )}
            href={__('https://docs.gandi.net/en/marketplace/index.html')}
          />

          <DocumentationGuide
            icon="envelopeDouble"
            title={__('Mailboxes and emails')}
            description={__(
              'Email configuration, antispam, forwarding, and FAQ.'
            )}
            href={__('https://docs.gandi.net/en/gandimail/index.html')}
          />

          <DocumentationGuide
            icon="simplehostingWire"
            title={__('Web Hosting')}
            description={__(
              'Website installation, databases, logs, console, commands.'
            )}
            href={__('https://docs.gandi.net/en/simple_hosting/index.html')}
          />

          <DocumentationGuide
            icon="gostackWire"
            title={__('GandiCloud VPS')}
            description={__('Server and resource management, billing, FAQ.')}
            href={__('https://docs.gandi.net/en/cloud/vps/index.html')}
          />

          <DocumentationGuide
            icon="secure"
            title={__('SSL Certificates')}
            description={__('Certificate types, CSR, required documents.')}
            href={__('https://docs.gandi.net/en/ssl/index.html')}
          />

          <DocumentationGuide
            icon="billingWire"
            title={__('Billing')}
            description={__('Accout payment method, orders, and invoices.')}
            href={__('https://docs.gandi.net/en/billing/index.html')}
          />

          <DocumentationGuide
            icon="team"
            title={__('Gandi Resellers')}
            description={__(
              'Benefits of being a Gandi reseller, customer management.'
            )}
            href={__('https://docs.gandi.net/en/reseller/index.html')}
          />
        </Base>
      </Intro>
    </Base>
  );
}

export default DocumentationGuides;
